import React, { useEffect } from "react";
import FileUpload from "./components/FileUpload";
import "./App.css";

// const tg = window.Telegram.WebApp;

function App() {
  // useEffect(() => {
  //   tg.ready();
  //   tg.expand();
  //   tg.enableClosingConfirmation();
  // }, []);

  return (
    <div className="App">
      <FileUpload />
    </div>
  );
}

export default App;
